import { buildStyleFromLiteral } from '../tools/services/styles-literal'
import { getColorArray } from '../tools/services/colors'

export default function ({ color = [51, 153, 204], lineWidth = 3, arrowWidth = 50 } = {}) {
  return (feature) => {
    const geometry = feature.getGeometry()

    if (geometry.getType() !== 'LineString') {
      return undefined
    }

    const [lastStart, lastEnd] = geometry.getCoordinates().slice(-2)
    const [arrowX, arrowY] = lastEnd
    const rotation = Math.atan2(lastEnd[1] - lastStart[1], lastEnd[0] - lastStart[0])

    return [
      buildStyleFromLiteral({
        stroke: { width: lineWidth, color: getColorArray(color) },
      }),
      buildStyleFromLiteral({
        geometry: { type: 'Point', coordinates: [arrowX, arrowY] },
        text: {
          font: `${arrowWidth}px Calibri,sans-serif`,
          text: 'V',
          textBaseline: 'middle',
          offsetY: -(Math.round(arrowWidth / 10)),
          rotation: -rotation + (Math.PI * 1.5),
          rotateWithView: true,
          fill: { color: getColorArray(color) },
        },
      }),
    ]
  }
}
